<script>
  import options from './DanmarksKort.options'
  export default options
</script>

<template>
  <article class="kb-danmarks-kort">
    <section class="kb-danmarks-kort__map-panel" :aria-label="mapPanelLabel">
      <DanmarksKortMap
        ref="mapRef"
        :title="title"
        :flow="flow"
        :group-data="groupData"
        :legend="legend"
        :municipality-data-url="municipalityDataUrl"
        :accessibility-list-label-municipality="accessibilityListLabelMunicipality"
        :accessibility-list-label-sundhedsraad="accessibilityListLabelSundhedsraad"
        :legend-label="legendLabel"
        :sr-tab="activeSrTab"
        @navigate="onNavigate"
        @load-error="onLoadError"
      />
    </section>
    <section class="kb-danmarks-kort__info-panel">
      <h2 class="kb-danmarks-kort__info-title">{{ infoTitle }}</h2>

      <div
        v-if="showSrToggle"
        class="kb-danmarks-kort__sr-toggle"
        role="group"
        :aria-label="srToggleAriaLabel"
      >
        <button
          type="button"
          class="kb-danmarks-kort__sr-toggle-btn"
          :class="{ 'kb-danmarks-kort__sr-toggle-btn--active': isTabSundhedsraad }"
          :aria-pressed="isTabSundhedsraad"
          @click="setSrTab('sundhedsraad')"
        >{{ srTabLabelSundhedsraad }}</button>
        <button
          type="button"
          class="kb-danmarks-kort__sr-toggle-btn"
          :class="{ 'kb-danmarks-kort__sr-toggle-btn--active': isTabKommuner }"
          :aria-pressed="isTabKommuner"
          @click="setSrTab('kommuner')"
        >{{ srTabLabelKommuner }}</button>
      </div>

      <FormInputCombobox
        v-if="showSearch"
        class="kb-danmarks-kort__search"
        field-id="danmarks-kort-search"
        :options="searchOptions"
        :aria-label="searchPlaceholder"
        :placeholder="searchPlaceholder"
        :button-label="searchButtonLabel"
        :no-results-label="searchNoResultsLabel"
        @select="onSearchSelect"
      />

      <p v-if="showSrSectionHeading" class="kb-danmarks-kort__section-heading">{{ srSectionHeading }}</p>
      <StatList v-if="showSrStats" :stats="activeDetail.stats" />

      <template v-if="showKommunerList">
        <p class="kb-danmarks-kort__section-heading">{{ kommunerSectionHeading }}</p>
        <div class="kb-accordion kb-accordion--dk-municipalities">
          <template v-for="(m, i) in srMunicipalities" :key="m.name">
            <h3 class="kb-accordion__question">
              <svg viewBox="0 0 705 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M705 1H2a1 1 0 0 0-1 1v9" stroke="#BFBFB7" />
              </svg>
              <button
                :id="'dk-sr-acc-q-' + i"
                :aria-controls="'dk-sr-acc-a-' + i"
                :aria-expanded="isMunicipalityOpen(m.name)"
                @click="toggleMunicipality(m.name)"
              >
                {{ m.name }} {{ municipalityNameSuffix }}
                <div
                  class="kb-accordion__question__chevron kb-ui-icon kb-ui-icon--ui-chevron-down"
                  :class="{ 'kb-accordion__question__chevron--open': isMunicipalityOpen(m.name) }"
                  aria-hidden="true"
                />
              </button>
            </h3>
            <div
              class="kb-accordion__answer"
              :class="{ 'kb-accordion__answer--open': isMunicipalityOpen(m.name) }"
              :id="'dk-sr-acc-a-' + i"
              role="region"
              :aria-labelledby="'dk-sr-acc-q-' + i"
            >
              <StatList v-if="m.stats" :stats="m.stats" />
            </div>
          </template>
        </div>
      </template>

      <p v-if="loadError" class="kb-danmarks-kort__error" role="alert">{{ loadErrorLabel }}</p>
      <p v-if="disclaimerText" class="kb-danmarks-kort__info-note">{{ disclaimerText }}</p>
    </section>
  </article>
</template>
